import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { VirtualAccountFilterType, VirtualAccountType } from "../graphql/types/VirtualAccountType";
import {
    VirtualAccountListResponse,
    GET_VIRTUAL_ACCOUNT_LISTING
} from "../graphql/queries/getVirtualAccountList";

export interface VirtualAccountQueryResult {
    virtualAccountData: VirtualAccountType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useVirtualAccountQuery = (
    filters: VirtualAccountFilterType,
    currentPage: number,
    pageSize: number
): VirtualAccountQueryResult => {
    const [virtualAccountData, setVirtualAccountData] = useState<VirtualAccountType[]>([]);
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState(0);

    const buildQueryVariables = () => {
        const queryFilters = {
            virtualAccountId: filters.virtualAccountId,
            clientId: filters.clientId,
        };

        return {
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "id",
                sortDirection: "DESC"
            }
        };
    };

    // 执行查询
    const { data, loading: queryLoading, refetch } = useQuery<VirtualAccountListResponse>(
        GET_VIRTUAL_ACCOUNT_LISTING,
        { variables: buildQueryVariables() }
    );

    // 当数据变化时更新状态
    useEffect(() => {
        const responseData = data?.getVirtualAccountPageable?.content;
        if (responseData) {
            setVirtualAccountData(responseData);
            setLoading(false);
        }
        const totalElements = data?.getVirtualAccountPageable?.totalElements;
        if (totalElements) {
            setTotal(totalElements);
        }
    }, [data]);

    return {
        virtualAccountData,
        loading: loading || queryLoading,
        refetch,
        totalElements: total,
        buildQueryVariables
    };
};
